"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Influxdata(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M10.196 2.043l8.844 2.683c.461.13.878.584.992 1.04l1.936 8.292c.11.455-.066 1.04-.418 1.386l-6.776 6.188a1.708 1.708 0 0 1-1.036.368c-.132 0-.263 0-.373-.043l-8.273-2.531c-.462-.13-.882-.585-.992-1.04L2.032 9.513c-.11-.434.066-1.04.418-1.343l6.337-5.802A1.708 1.708 0 0 1 9.823 2c.132 0 .263 0 .373.043zm-3.1 11.773L5.93 17.495a.455.455 0 0 0 .308.563l6.952 2.123a.508.508 0 0 0 .571-.325l1.167-3.68a.455.455 0 0 0-.307-.562l-6.952-2.101c-.242-.065-.505.065-.571.303zm12.142 1.191l-3.191.715a.806.806 0 0 0-.57.52l-.97 3.076c-.066.238.021.303.197.13l4.644-4.246c.175-.173.131-.281-.11-.195zm-15.244-4.48l1.405 6.083c.044.238.154.238.22 0l.97-3.072c.065-.238 0-.585-.177-.758l-2.22-2.361c-.154-.174-.264-.13-.198.108zm14.014-4.09l-3.827.866c-.242.065-.395.303-.33.542l1.629 6.97c.066.24.307.39.549.326l3.827-.867c.242-.043.395-.281.33-.541l-1.629-6.971a.453.453 0 0 0-.549-.325zm-5.082 1.577l-5.017 4.592c-.176.174-.132.369.11.434l6.557 1.992c.242.062.395-.068.33-.306l-1.541-6.582c-.066-.238-.264-.303-.44-.13zm-3.502-4L4.1 8.884a.44.44 0 0 0-.022.629l2.66 2.834c.176.173.461.195.637.021l5.324-4.87c.176-.173.197-.455.022-.628l-2.66-2.834c-.176-.173-.461-.195-.637-.022zm1.606.217l2.221 2.361c.176.173.505.282.747.217l3.19-.715c.242-.065.242-.173 0-.238l-6.07-1.842c-.241-.065-.285.022-.088.217z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Influxdata;
